import { Route, Router, Set } from '@redwoodjs/router';
import { PageType } from '@redwoodjs/router/dist/router';

import ViewTrialMerchantPage from 'src/pages/ViewTrialMerchantPage/ViewTrialMerchantPage';

import { AddMerchantProvider } from './contexts/AddMerchantProvider';
import { AuthProvider } from './contexts/AuthProvider';
import MainLayout from './layouts/MainLayout/MainLayout';
import { YellowLayout } from './layouts/YellowLayout';
import AccountStatementsPage from './pages/AccountStatementsPage/AccountStatementsPage';
import AddCreditNotePage from './pages/AddCreditNotePage';
import AddMccPage from './pages/AddMccPage/AddMccPage';
import AddMerchantPage from './pages/AddMerchantPage/AddMerchantPage';
import AddPartnerPage from './pages/AddPartnerPage';
import AddSalesInvoicePage from './pages/AddSalesInvoicePage';
import AddServicePage from './pages/AddServicePage/AddServicePage';
import AddTerminalPricingPage from './pages/AddTerminalPricingPage/AddTerminalPricingPage';
import AuditLogPage from './pages/AuditLogPage/AuditLogPage';
import CancellationReasonsPage from './pages/CancellationReasonsPage/CancellationReasonsPage';
import CancelMerchantPage from './pages/CancelMerchantPage/CancelMerchantPage';
import CheckInCallSetupPage from './pages/CheckInCallSetupPage';
import ConfigurePartnerResource from './pages/ConfigurePartnerResources/ConfigurePartnerResourcesPage';
import CheckInCallsPage from './pages/CustomerSuccess/CheckInCalls';
import EditMCCPage from './pages/EditMCCPage/EditMCCPage';
import EditProductPage from './pages/EditProductPage/EditProductPage';
import EditTerminalPricingPage from './pages/EditTerminalPricingPage/EditTerminalPricingPage';
import ManagePartnerResourcesPage from './pages/ManagePartnerResourcesPage/ManagePartnerResources';
import MCCPage from './pages/MccPage/MccPage';
import MerchantApplicationPage from './pages/MerchantApplicationPage/MerchantApplicationPage';
import MerchantApplicationsPage from './pages/MerchantApplicationsPage/MerchantApplicationsPage';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import RemoveStockReasonsPage from './pages/RemoveStockReasonsPage/RemoveStockReasonsPage';
import ResetPasswordPage from './pages/ResetPasswordPage/ResetPasswordPage';
import SuspendedReasonsPage from './pages/SuspendedReasonsPage/SuspendedReasonsPage';
import UserManagementPage from './pages/UserManagementPage/UserManagementPage';
import ViewAccountStatementPage from './pages/ViewAccountStatementPage';
import CheckInCallDashboardPage from './pages/ViewCheckInCallPage';
import ViewCommissionStatementPage from './pages/ViewCommissionStatementPage/ViewCommissionStatementPage';
import ViewCreditNotePage from './pages/ViewCreditNotePage/ViewCreditNotePage';
import ViewCreditsPage from './pages/ViewCreditsPage/ViewCreditsPage';
import ViewMCCPage from './pages/ViewMCCPage/ViewMCCPage';
import ViewMerchantPage from './pages/ViewMerchantPage/ViewMerchantPage';
import ViewMerchantsPage from './pages/ViewMerchantsPage/ViewMerchantsPage';
import ViewOnlineCommissionsPage from './pages/ViewOnlineCommissionsPage/ViewOnlineCommissionsPage';
import ViewPartnerPage from './pages/ViewPartnerPage/ViewPartnerPage';
import ViewPartnerResourcesPage from './pages/ViewPartnerResources/ViewPartnerResources';
import ViewPartnerShopPage from './pages/ViewPartnerShopPage/ViewPartnerShopPage';
import ProductPage from './pages/ViewProductPage/ViewProductPage';
import ProductsPage from './pages/ViewProductsPage/ViewProductsPage';
import ViewSalesInvoicePage from './pages/ViewSalesInvoicePage';
import ViewSalesInvoicesPage from './pages/ViewSalesInvoicesPage/ViewSalesInvoicesPage';
import ViewSelfBillingInvoicePage from './pages/ViewSelfBillingInvoicePage/ViewSelfBillingInvoicePage';
import ViewSelfBillingInvoicesPage from './pages/ViewSelfBillingInvoicesPage/ViewSelfBillingInvoicesPage';
import ViewTerminalCommissionsPage from './pages/ViewTerminalCommissionsPage/ViewTerminalCommissionsPage';
import ViewTransactionCommissionsPage from './pages/ViewTransactionCommissionsPage/ViewTransactionCommissionsPage';
import AuthGuard from './utils/route-guard/AuthGuard';
import LoggedInGuard from './utils/route-guard/LoggedInGuard';
type RouteProps = {
    path: string;
    name: string;
    page: PageType;
    basePath: string;
};

export const PUBLIC_ROUTES: RouteProps[] = [
    { name: 'login', page: LoginPage, path: '/login', basePath: '/login' },
    { name: 'resetPassword', page: ResetPasswordPage, path: '/reset-password/{resetToken}', basePath: '/reset-password' },
    { name: 'createPassword', page: ResetPasswordPage, path: '/create-password/{resetToken}', basePath: '/create-password' },
];

const Routes = () => {
    return (
        <Router>
            <Set wrap={AuthProvider}>
                <Set wrap={[YellowLayout]}>
                    {PUBLIC_ROUTES.map((route) => {
                        return <Route path={route.path} name={route.name} page={route.page} key={route.name} />;
                    })}
                </Set>
                <Set wrap={[LoggedInGuard, YellowLayout]}>
                    <Route path="/verification" name="verification" page={VerificationPage} key="verification" />
                </Set>
                <Set wrap={[AuthGuard, MainLayout]}>
                    <Route path="/" page={HomePage} name="home" />
                    <Route path="/home" page={HomePage} name="home" />
                    <Route path="/user-management/users" page={UserManagementPage} name="users" />
                    <Route path="/user-management/users/{id:Int}" page={EditUserPage} name="viewUser" />
                    <Route path="/user-management/add-user" page={AddUserPage} name="addUser" />
                    <Route path="/user-management/user-roles" page={RolesPage} name="roles" />
                    <Route path="/user-management/add-user-role" page={AddUserRolePage} name="addUserRole" />
                    <Route path="/user-management/view-user-role" page={EditUserRolePage} name="editUserRole" />
                    <Route path="/partners" page={PartnersPage} name="partners" />
                    <Route path="/partner/add" page={AddPartnerPage} name="addPartner" />
                    <Route path="/partner/{id:Int}" page={ViewPartnerPage} name="viewPartner" />
                    <Route path="/partner/{id:Int}?partnerOfPartner={partnerOfPartner:boolean}" page={ViewPartnerPage} name="viewPartner" />
                    <Route path="/profile" page={ProfilePage} name="profile" />
                    <Route path="/profile/{code}" page={ProfilePage} name="profile" />
                    <Route path="/mccs" page={MCCPage} name="mccs" />
                    <Route path="/mccs/add" page={AddMccPage} name="addMcc" />
                    <Route path="/mccs/{id:Int}" page={ViewMCCPage} name="viewMcc" />
                    <Route path="/mccs/{id:Int}/edit" page={EditMCCPage} name="editMcc" />
                    <Set wrap={AddMerchantProvider}>
                        <Route path="/merchant/add" page={AddMerchantPage} name="addMerchant" />
                    </Set>
                    <Route path="/online-pricing" page={ViewOnlinePricingPage} name="viewOnlinePricing" />
                    <Route path="/online-pricing/add" page={AddOnlinePricingPage} name="addOnlinePricing" />
                    <Route path="/online-pricing/{id:Int}/edit" page={EditOnlinePricingPage} name="editOnlinePricing" />
                    <Route path="/products" page={ProductsPage} name="viewProducts" />
                    <Route path="/products/add" page={AddProductPage} name="addProduct" />
                    <Route path="/products/{id:Int}" page={ProductPage} name="viewProduct" />
                    <Route path="/products/{id:Int}/edit" page={EditProductPage} name="editProduct" />
                    <Route path="/terminal-pricing" page={ViewTerminalPricingsPage} name="viewTerminalPricings" />
                    <Route path="/terminal-pricing/add" page={AddTerminalPricingPage} name="addTerminalPricing" />
                    <Route path="/terminal-pricing/{id:Int}/edit" page={EditTerminalPricingPage} name="editTerminalPricing" />
                    <Route path="/merchant-applications/view" page={MerchantApplicationsPage} name="merchantApplications" />
                    <Set wrap={AddMerchantProvider}>
                        <Route path="/merchant/{merchantId:Int}/add-service" page={AddServicePage} name="AddService" />
                    </Set>
                    <Route path="/merchants" page={ViewMerchantsPage} name="merchants" />
                    <Route path="/merchant/cancel" page={CancelMerchantPage} name="cancelMerchant" />
                    <Route path="/merchant/{merchantAccountNumber:String}" page={ViewMerchantPage} name="viewMerchant" />
                    <Route path="/config/cancellation-reasons" page={CancellationReasonsPage} name="cancellationReasons" />
                    <Route path="/config/suspended-reasons" page={SuspendedReasonsPage} name="suspendedReasons" />
                    <Route path="/config/remove-stock-reasons" page={RemoveStockReasonsPage} name="removeStockReasons" />
                    <Route path="/merchant-applications/view-application/{id:Int}" page={MerchantApplicationPage} name="viewMerchantApplication" />
                    <Route path="/config/audit-log" page={AuditLogPage} name="auditLog" />
                    <Route path="/transaction-pricing" page={TransactionPricingPage} name="transactionPricing" />
                    <Route path="/transaction-pricing/{id:Int}" page={ViewTransactionPricingPage} name="viewTransactionPricing" />
                    <Route path="/add-transaction-pricing" page={AddTransactionPricingPage} name="addTransactionPricing" />
                    <Route path="/finance/sales-invoices" page={ViewSalesInvoicesPage} name="viewSalesInvoices" />
                    <Route path="/finance/sales-invoice/{id}" page={ViewSalesInvoicePage} name="viewSalesInvoice" />
                    <Route path="/finance/sales-invoices/add" page={AddSalesInvoicePage} name="addSalesInvoice" />
                    <Route path="/finance/commissions/{commissionType:String}/{id:Int}" page={ViewCommissionStatementPage} name="viewCommissionStatement" />
                    <Route path="/finance/commissions/online" page={ViewOnlineCommissionsPage} name="viewOnlineCommissionsPage" />
                    <Route path="/finance/commissions/terminal" page={ViewTerminalCommissionsPage} name="viewTerminalCommissionsPage" />
                    <Route path="/finance/commissions/transaction" page={ViewTransactionCommissionsPage} name="viewTransactionCommissionsPage" />
                    <Route path="/finance/self-billing-invoices" page={ViewSelfBillingInvoicesPage} name="viewSelfBillingInvoices" />
                    <Route path="/finance/self-billing-invoices/{id}" page={ViewSelfBillingInvoicePage} name="viewSelfBillingInvoicePage" />
                    <Route path="/finance/credits" page={ViewCreditsPage} name="credits" />
                    <Route path="/finance/credits/add" page={AddCreditNotePage} name="addCredits" />
                    <Route path="/finance/credits/{id:Int}" page={ViewCreditNotePage} name="viewCreditNote" />
                    <Route path="/finance/direct-debits" page={DirectDebitsPage} name="directDebits" />
                    <Route path="/finance/account-statements" page={AccountStatementsPage} name="accountStatements" />
                    <Route path="/finance/account-statements/{id}" page={ViewAccountStatementPage} name="viewAccountStatement" />
                    <Route path="/partner-resources/view" page={ViewPartnerResourcesPage} name="viewPartnerResources" />
                    <Route path="/partner-resources/manage" page={ManagePartnerResourcesPage} name="managePartnerResources" />
                    <Route path="/config/partner-resources" page={ConfigurePartnerResource} name="configurePartnerResource" />
                    <Route path="/partner-shops" page={ViewPartnerShopPage} name="shops" />
                    <Route path="/config/check-in-call-setup" page={CheckInCallSetupPage} name="checkInCallSetup" />
                    <Route path="/config/check-in-call-view/{id}" page={CheckInCallViewPage} name="checkInCallView" />
                    <Route path="/customer-success/check-in-calls" page={CheckInCallsPage} name="checkInCalls" />
                    <Route path="/customer-success/check-in-calls/{serviceId:Int}" page={CheckInCallDashboardPage} name="checkInCallDashboard" />
                    <Route path="/trial-merchants" page={ViewTrialMerchantsPage} name="trialMerchants" />
                    <Route path="/trial-merchants/{serviceId:Int}" page={ViewTrialMerchantPage} name="trialMerchantDashboard" />
                </Set>
                <Route notfound page={NotFoundPage} />
            </Set>
        </Router>
    );
};

export default Routes;
